/* global debounce, attachEvent, slideToggle, windowWidth, breakpointMd */

// *******************************************************************************
// Mobile menu toggle
// *******************************************************************************

attachEvent('.mobile-hamburger', 'click', (ev) => {
  // Open menu
  document.body.classList.toggle('is-open-menu');
  document.body.classList.remove('is-open-lotric-group');
  const hamburger = ev.target.closest('.mobile-hamburger');
  const isOpen = hamburger.classList.contains('is-open');
  hamburger.classList.toggle('is-open', !isOpen);
  hamburger.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
  ev.preventDefault();
});

// *******************************************************************************
// Add class to body after some scroll
// *******************************************************************************
function addScrollingClass() {
  const topOffert = document.documentElement.scrollTop || document.body.scrollTop;
  document.body.classList.toggle('is-scrolled', topOffert > 20);
}

// *******************************************************************************

let lastScrollTop = 0;

window.addEventListener('scroll', () => {
  const isScrolledTop = window.pageYOffset || document.documentElement.scrollTop;
  if (isScrolledTop > lastScrollTop) {
    document.body.classList.remove('is-scrolled-up');
  } else {
    document.body.classList.add('is-scrolled-up');
  }
  lastScrollTop = isScrolledTop <= 0 ? 0 : isScrolledTop;
},
false);

// Debounce the function to prevent multiple executions on scroll event
const debounceScroll = debounce(() => {
  addScrollingClass();
}, 50);

window.addEventListener('scroll', debounceScroll);

// *******************************************************************************
// Open lotric group
// *******************************************************************************
attachEvent('.lotric-dropdown-btn', 'click', (ev) => {
  document.body.classList.toggle('is-open-lotric-group');
  document.body.classList.remove('is-open-menu');
  ev.preventDefault();
});

// *******************************************************************************
// Close lotric group
// *******************************************************************************
attachEvent('.lotric-group__close', 'click', (ev) => {
  document.body.classList.remove('is-open-lotric-group');
  ev.preventDefault();
});

// *******************************************************************************
// Calc lotric group modal height
// *******************************************************************************
const lotricGroupElem = document.querySelector('.lotric-group');

function calcLotricGroupHeight() {
  const vh = lotricGroupElem.clientHeight;
  document.documentElement.style.setProperty('--lotricHeight', `${vh}px`);
}

if (lotricGroupElem) {
  window.onload = () => {
    calcLotricGroupHeight();
  };

  const debounceCalcLotricGroupHeight = debounce(() => {
    calcLotricGroupHeight();
  }, 100);

  window.addEventListener('resize', () => {
    debounceCalcLotricGroupHeight();
  });
}

// *******************************************************************************
// Open search in mobile
// *******************************************************************************
attachEvent('.search-trigger', 'click', (ev) => {
  document.body.classList.toggle('is-open-search');
  ev.preventDefault();

  setTimeout(() => {
    const searchInput = document.querySelector('.search-field__input');
    searchInput.focus();
  }, 300);
});
